import React from "react";
import "./WhatIsClassplus.scss";

const WhatIsClassplus = () => {
	return (
		<div className='whatIsClassplus'>
			<div className='whatIsClassplus__text'>
				<h3>What is Classplus?</h3>
				<p>
					Today, mankind creates more data every day, than what it has created
					cumulatively till now, counting right from the Stone Age. Welcome to
					the Smartphone Age! This shift has been radical than incremental. But
					what hasn’t diluted even a bit in these hundreds of ages is the
					reverence of tutelage and the constant urge to learn. We combined
					these two unstoppable paradigms and blended them with the Indian
					Coaching Market and the fledging Digital Content Creation Industry.
					And voila, here we are! Redefining how educators and creators teach
					using their own mobile apps to grow their online business.
				</p>
			</div>
			<div className='whatIsClassplus__numbers'>
				<div className='whatIsClassplus__numbers__singleNum whatIsClassplus__numbers__singleNum--first'>
					<h3>1 L+</h3>
					<p>
						Educators use our <br />
						platform globally
					</p>
				</div>
				<div className='whatIsClassplus__numbers__singleNum whatIsClassplus__numbers__singleNum--second'>
					<h3>78%</h3>
					<p>
						Customers belong to <br /> Tier 2 Tier 3 cities
					</p>
				</div>
				<div className='whatIsClassplus__numbers__singleNum whatIsClassplus__numbers__singleNum--third'>
					<h3>₹500  Cr+</h3>
					<p>
						Earned by our educators<br /> using their apps
					</p>
				</div>
				<div className='whatIsClassplus__numbers__singleNum whatIsClassplus__numbers__singleNum--fourth'>
					<h3>700+</h3>
					<p>Clan Members</p>
				</div>
			</div>
		</div>
	);
};

export default WhatIsClassplus;
